export default "__VITE_PUBLIC_ASSET__4d909d9f__"